export default __webpack_public_path__ + "static/media/download.2c31e860.svg";